<template>
  <div>
    <md-button v-if="computedMode === 'btn'" @click="click" class="md-icon-button md-dense" :class="dynamicClass">
      <md-tooltip v-if="enableTooltip">{{ dynamicTooltipMessage }}</md-tooltip>
      <span :class="dynamicIcon"></span>
    </md-button>
    <md-switch v-if="computedMode === 'switch'" v-model="isActive">{{ switchText }}</md-switch>
  </div>
</template>

<script>
import { computed, ref, watch } from "@vue/composition-api";
const modeChoices = new Set(["btn", "switch"]);
export default {
  name: "OnOffButton",
  props: {
    activeClass: {
      type: String,
      default: "md-primary",
    },
    inactiveClass: {
      type: String,
      default: "md-inactive",
    },
    activeIcon: {
      type: String,
      default: "fa fa-eye-slash",
    },
    inactiveIcon: {
      type: String,
      default: "fa fa-eye",
    },
    enableTooltip: {
      type: Boolean,
      default: true,
    },
    activeTooltipMessage: {
      type: String,
      default: "Turn off",
    },
    inactiveTooltipMessage: {
      type: String,
      default: "Turn on",
    },
    commonClasses: {
      type: String,
      default: "",
    },
    switchText: {
      type: String,
      default: "off/on",
    },
    mode: {
      type: String,
      default: () => [...modeChoices].at(0),
    },
  },
  setup(props, { emit }) {
    const isActive = ref(false);
    const click = () => {
      isActive.value = !isActive.value;
    };
    watch(
      () => isActive.value,
      () => emit("click")
    );
    const dynamicColor = () => (isActive.value ? props.activeClass : props.inactiveClass);
    const dynamicClass = computed(() => `${dynamicColor()} ${props.commonClasses}`);
    const dynamicIcon = computed(() => (isActive.value ? props.activeIcon : props.inactiveIcon));
    const dynamicTooltipMessage = computed(() =>
      isActive.value ? props.activeTooltipMessage : props.inactiveTooltipMessage
    );
    const computedMode = computed(() => (modeChoices.has(props.mode) ? props.mode : [...modeChoices].at(0)));
    return {
      isActive,
      click,
      dynamicClass,
      dynamicIcon,
      dynamicTooltipMessage,
      computedMode,
    };
  },
};
</script>

<style scoped></style>
